import { UserStore } from './user';
import {createContext, useContext} from "react";
import {OnboardingStore} from "./onboarding";
import {PlagiarismStore} from "./plagiarism";
import {HistoryStore} from "./history";
import {SocialMediaStore} from "./socialMedia";
import {makeAutoObservable} from "mobx";
import {InputStore} from "./input";

export class Root {

    error = null;

    getUser() {
        return this.user.user
    }

    async doRefresh() {
        await this.user.refresh()
        await this.history.loadHistory()
        this.socialMedia.refreshSocial()
    }

    async refresh() {
        try {
            await this.doRefresh()
        } catch (err) {
            this.setError('Failed to refresh')
        }
    }

    setError(error) {
        this.error = error
    }

    constructor() {
        this.user = new UserStore(this);
        this.input = new InputStore(this)
        this.history = new HistoryStore(this);
        this.onboarding = new OnboardingStore(this);
        this.plagiarism = new PlagiarismStore(this);
        this.socialMedia = new SocialMediaStore(this)

        makeAutoObservable(this)
    }
}

export const rootStore = new Root();
export const StoreContext = createContext(rootStore);

export const useStores = () => useContext(StoreContext);
